module.exports = __webpack_public_path__ + "img/main-page-logo-adaptive.68ba1da4.svg";